const opts = {
  filterable: true,
  sortable: false
};
export default {
  id: 'sale.locatorReplacementType',
  name: 'sale.locatorReplacementType',
  displayName: 'Locator Type',
  valueType: 'string',
  objectType: 'sale',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const {
      replacementTimestamp
    } = obj?.data || {};
    return replacementTimestamp == null ? 'Original Locator' : 'Replacement Locator';
  }
};